import React, { useEffect, useState } from "react";
import "./order.css";
import Notes from './header';
import FooterManual from "./footerManual";
import { useNavigate } from "react-router-dom";
import { fetchCart } from "./store";
import { useDispatch } from "react-redux";

const Orderpage = () => {
  const [orderDetails, setOrderDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    // Prevent going back
    const handleBackButton = (e) => {
      e.preventDefault();
      window.history.forward();
    };

    window.history.pushState(null, null, window.location.pathname);
    window.addEventListener('popstate', handleBackButton);

    const fetchOrderDetails = async () => {
      try {
        const token = localStorage.getItem("authToken");
        if (!token) {
          throw new Error('No token found in localStorage');
        }

        const response = await fetch('https://car.amar.co.jp/api/dashboard/checkout/order-specific/details', {
          method: 'GET',
          headers: {
            'accept': 'application/json',
            'Accept-Language': 'en',
            'Authorization': `Bearer ${token}`
          }
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        setOrderDetails(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
        dispatch(fetchCart());
      }
    };

    fetchOrderDetails();

    return () => {
      window.removeEventListener('popstate', handleBackButton);
    };
  }, []);

  if (loading) {
    return <div className="loading-message">Loading order details...</div>;
  }

  if (error) {
    return <div className="error-message">Error: {error}</div>;
  }

  // Get the first order details (assuming there might be multiple)
  const firstOrder = orderDetails?.orderSpecificDetails?.[0] || {};

  return (
    <div>
      <Notes />

      {/* Responsive Body Content */}
      <div className="responsive-body">
        <div className="order-confirmation-box">
          <h2 className="confirmation-title">
            Thank you for shopping with AmarCar! 🚗
          </h2>

          <p className="confirmation-message">
            Your order has been successfully placed and is now being processed.
            We appreciate your trust in us and look forward to helping you find your perfect car.
          </p>

          <div className="order-summary">
            <h3>Order Summary:</h3>
            <p><strong>Order ID:</strong> {firstOrder.orderRefId || 'N/A'}</p>
            <p><strong>Date:</strong> {firstOrder.orderCreatedDate || 'N/A'}</p>
            <p><strong>Payment Status:</strong>
              <span className={`${firstOrder.paymentStatus?.toLowerCase()}-status`}>
                {firstOrder.paymentStatus || 'N/A'}
              </span>
            </p>
          </div>

          <p className="bank-transfer-info">
            To complete your purchase, please transfer the payment via bank transfer and upload the payment receipt.
          </p>

          <div className="upload-instructions">
            <h4>👉 How to Upload the Receipt:</h4>
            <ol>
              <li>Hover over "Profile" in the top menu</li>
              <li>Click on "Order History"</li>
              <li>Find your recent order</li>
              <li>Click on the "Upload Receipt" box and attach your payment proof</li>
            </ol>
          </div>

          <p className="important-note">
            Note: Your order will not be processed until we verify your payment.
          </p>

          <p className="support-message">
            If you need help, feel free to contact our support team.
          </p>

          <p className="closing-message">
            Thank you for choosing AmarCar – Drive your dream.
          </p>
        </div>

        <div className="status-box pending">
          <h3>Payment Pending</h3>
          <p>Please complete your bank transfer and upload the receipt.</p>
        </div>
      </div>

      <FooterManual />
    </div>
  );
};

export default Orderpage;
